import {BasketTooltip} from '@dms/api/shared';

import {Nullish} from 'shared/web';

import {PriceWithAndWithoutVat} from './PriceWithAndWithoutVat';

export type BasketItem = {
  id: string;
  name: string;
  quantity: number;
  itemEditingAllowed: boolean;
  quantityEditingAllowed: boolean;
  unitPrice: PriceWithAndWithoutVat;
  totalPrice: PriceWithAndWithoutVat;
  number?: string;
  manufacturerNumber?: string;
  warehouse_id?: string;
  unit?: string | null;
  discount?: {rate?: number | Nullish} & PriceWithAndWithoutVat;
  tooltip?: BasketTooltip[];
};
